module.exports = __webpack_public_path__ + "img/Group 3.ab327c58.svg";